import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {Equipe} from '../models/equipe';
import {User} from '../models';


const httpOptions = {
  headers: new HttpHeaders({'Content-Type': 'application/json'})
};
const apiUrl = '/api/v1/mailling';

@Injectable()
export class MaillingService {

  constructor(private http: HttpClient) { }

  findInboxByPage(p: number, size: number, folder: string): Observable<any> {
    const params = new HttpParams()
        .set('page', String(p))
        .set('pageSize', String(size))
        .set('folder', String(folder));
    const url = `${apiUrl}/inbox`;
    return this.http.get<any>(url, {params});
  }

  folders(): Observable<any> {
    const url = `${apiUrl}/folders`;
    return this.http.get<any>(url);
  }

  findMessage(folder: string, numero: number): Observable<any> {
    const params = new HttpParams()
        .set('folder', String(folder))
        .set('numero', String(numero));
    const url = `${apiUrl}/message`;
    return this.http.get<any>(url, {params});
  }

  downloadFileFromMessage(att: string, folder: string, numero: number): Observable<any> {
    const params = new HttpParams()
        .set('filename', String(att))
        .set('folder', String(folder))
        .set('numero', String(numero));
    const url = `${apiUrl}/downloadFile`;
    return this.http.get<any>(url, {params});
  }


  sendMail(mail: any, files: any[]) {
    const formData = new FormData();
    for (let i = 0; i < files.length; i++) {
      formData.append('file' + i, files[i]);
    }
    formData.append('mail', new Blob([JSON.stringify(mail)], { type: 'application/json' }));
    return this.http.post<any>(apiUrl + '/send', formData, {
      reportProgress: true,
      observe: 'events'
    });
  }

}
